import { createApi } from '@reduxjs/toolkit/query/react';
import { endPoints, urlKeys } from 'src/api/APIEndpoints';
import { archLevel } from 'src/data/config';
import { formatString } from 'src/util/STR';
import { baseQuery } from './baseQuery';

export const sivConfirmationLetterApi = createApi({
  baseQuery,
  reducerPath: 'sivConfirmationLetterApi',
  endpoints: builder => ({
    getSivConfrimationLetter: builder.query<any, any>({
      query: ({ site_id, study_id, country }) => ({
        url: `${formatString(
          endPoints.sivConfirmationLatter.getAll
        )}?site_id=${site_id}&study_id=${study_id}&country=${country}&application=${
          archLevel == 'sponsor' ? process.env.REACT_APP_NAME : process.env.REACT_APP_NAME_TEMP
        }`,
        method: 'GET'
      }),
      extraOptions: { maxRetries: 3 }
    }),
    selectSivConfrimationLetter: builder.query<any, any>({
      query: ({
        site_id,
        study_id,
        country,
        application_section = 'STARTUP',
        application_module_section = 'STUDY LOGS',
        siv_visit_id
      }) => ({
        url: `${formatString(
          endPoints.sivConfirmationLatter.select,
          { key: urlKeys.site_id, value: site_id },
          { key: urlKeys.study_id, value: study_id }
        )}?country=${country}&application=${
          archLevel == 'sponsor' ? process.env.REACT_APP_NAME : process.env.REACT_APP_NAME_TEMP
        }&application_section=${application_section}&application_module_section=${application_module_section}${
          siv_visit_id !== null || siv_visit_id !== undefined ? `&siv_visit_id=${siv_visit_id}` : ''
        }`,
        method: 'GET'
      }),
      extraOptions: { maxRetries: 3 }
    }),
    updateSivConfrimationLetter: builder.mutation<any, any>({
      query: ({
        site_id,
        study_id,
        country,
        application_section = 'STARTUP',
        application_module_section = 'STUDY LOGS',
        data
      }) => ({
        url: `${formatString(
          endPoints.sivConfirmationLatter.update,
          { key: urlKeys.site_id, value: site_id },
          { key: urlKeys.study_id, value: study_id }
        )}?country=${country}&application=${
          archLevel == 'sponsor' ? process.env.REACT_APP_NAME : process.env.REACT_APP_NAME_TEMP
        }&application_section=${application_section}&application_module_section=${application_module_section}`,
        method: 'PUT',
        body: data
      }),
      extraOptions: { maxRetries: 3 }
    }),
    publishSivConfrimationLetter: builder.mutation<any, any>({
      query: ({
        site_id,
        study_id,
        country,
        monitoring_visit_id,
        publish_doc_version,
        time_zone_id,
        is_published,
        update
      }) => ({
        url: `${formatString(
          endPoints.sivConfirmationLatter.publish,
          { key: urlKeys.site_id, value: site_id },
          { key: urlKeys.study_id, value: study_id }
        )}?country=${country}&application=${
          archLevel == 'sponsor' ? process.env.REACT_APP_NAME : process.env.REACT_APP_NAME_TEMP
        }&monitoring_visit_id=${monitoring_visit_id}&publish_doc_version=${publish_doc_version}&time_zone_id=${time_zone_id}&is_published=${is_published}&update=${update}`,
        method: 'POST'
      }),
      extraOptions: { maxRetries: 3 }
    }),
    createNewVersion: builder.mutation<any, any>({
      query: ({ site_id, study_id, country, application, application_section, sq_visit_id }) => ({
        url: `${formatString(
          endPoints.sivConfirmationLatter.createNewVersion,
          { key: urlKeys.site_id, value: site_id },
          { key: urlKeys.study_id, value: study_id },
          { key: urlKeys.sq_visit_id, value: sq_visit_id }
        )}?country=${country}&application=${application}&application_section=${application_section}&application_module_section=STUDY LOGS`,
        method: 'POST'
      })
    })
  })
});

export const {
  useLazyGetSivConfrimationLetterQuery,
  useLazySelectSivConfrimationLetterQuery,
  useUpdateSivConfrimationLetterMutation,
  usePublishSivConfrimationLetterMutation,
  useCreateNewVersionMutation
} = sivConfirmationLetterApi;
